import React, { useEffect, useState } from "react";
import { Typography, TextField, Box } from "@mui/material";
import {
  isMinLessThanMax,
  validateNumberInput,
  validateStringInput,
} from "../CartConfigurationService";

interface CustomInputFieldProps {
  label: string;
  values: Record<string, any>;
  inputValidation: {
    max: number;
    min: number;
  };
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  name: string;
  type: "string" | "number";
  isSaveAttempted: boolean;
  placeholder: string;
}

const CustomInputField: React.FC<CustomInputFieldProps> = ({
  label,
  values,
  inputValidation,
  handleInputChange,
  name,
  type,
  isSaveAttempted,
  placeholder,
}) => {
  const [error, setError] = useState<string>("");
  const handleInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (type === "string") {
      if (inputValidation.max < e.target.value.length) return;
      handleInputChange(e);
      
      // Only validate if save has been attempted
      // if (isSaveAttempted) {
        setError(validateStringInput(e.target.value, inputValidation));
      // }
    } else {
      // if (!e.target.value) return; // Number field can't be empty
      // parse e.target.value to string if it is a number then get the number of digits in that 
      // and then check this logic and if input digit is more than that then dont let it input it
      if (e.target.value && (parseFloat(e.target.value) < 0 || e.target.value.toString().length > inputValidation.max)) return;
      // if (inputValidation.min >= parseInt(e.target.value)) return;
      handleInputChange(e);
      checkForMinLessThanMaxError();
      // Only validate if save has been attempted
      // if (isSaveAttempted) {
        setError(validateNumberInput(e.target.value, inputValidation) || checkForMinLessThanMaxError());
      // }
      
    }
  };
   const isMinLessThanMax_local = (
    values: Record<string, any>,
    param?: string
  ): string => {
    // ;
    const orderValidationTypes = values?.orderValidationType?.split(",") ?? [];
    const orderingCriteriaTypes = values?.orderingCriteriaType
      ? values?.orderingCriteriaType
          .split(",")
          .slice(0, Math.min(2, values?.orderingCriteriaType?.split(",")?.length))
      : [];
    if (orderValidationTypes.length === 2 && orderingCriteriaTypes.length === 1) {
      const criteria = orderingCriteriaTypes[0]; // Single ordering criteria type
  
      const minValue = parseInt(values?.[`min_${criteria}`], 10);
      const maxValue = parseInt(values?.[`max_${criteria}`], 10);
  
      if (!isNaN(minValue) && !isNaN(maxValue) && minValue >= maxValue) {
        // ;
        if (param === "max")
          return "Max value should be greater than min value";
        else
          return "Min value should be less than max value";
      }
    }
    return "";
  };
  const checkForMinLessThanMaxError = () : string =>{
    if(name.split("_").includes("max")){
      return isMinLessThanMax_local(values,"max")
    }
    else if(name.split("_").includes("min")){
      return isMinLessThanMax_local(values,"min")

    }
    return "";
  }
  const checkForErrors = () => {
    if (values[name] !== undefined)  {
      setError(
        type === "string"
          ? validateStringInput(values[name], inputValidation)
          :( validateNumberInput(values[name], inputValidation) || checkForMinLessThanMaxError())
      );
    }
  };
  // useEffect(()=>{
  //   // ;
  //   const error = checkForMinLessThanMaxError();
  //   if(type === "number"){
  //     setError(error);
  //   }
  // },[values])
  useEffect(()=>{
    // if(isSaveAttempted){
      checkForErrors();
    // }
  },[isSaveAttempted,values])

  return (
    <>
      <Box
        sx={{
          // width: label.length > 30 ? "80%" : "70%",
          display: "flex",
          gap: 1,
          alignItems: "center",
        }}
      >
        
        <Typography
          sx={{
            marginRight: "1rem",
            width: "auto",
            flexGrow: 1,
            overflow: "visible",
            color: "#606060",
            whiteSpace: "nowrap",
            alignSelf: !!error ? "flex-start" : "center",
            paddingTop: !!error ? "10px" : "0",
          }}
        >
          {label}
        </Typography>
        <TextField
          variant="outlined"
          name={name}
          type={type}
          value={type === "number" ? values?.[name] : values?.[name]}
          onChange={handleInput}
          error={!!error}
          helperText={error}
          placeholder={placeholder}
          sx={{
        marginY: "5px",
        borderRadius: "20px",
        width: "clamp(250px, 50%, 250px)",
        maxWidth: "250px",
        "& .MuiOutlinedInput-root": {
          padding: "0",
          height: "40px",
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "8px",
          },
          "& input": {
            paddingY: "8px",
            textAlign: "center",
            height: "100%",
          },
        },
          }}
        />
      </Box>
    </>
  );
};

export default CustomInputField;
